import { render, staticRenderFns } from "./RejectionCauseList.vue?vue&type=template&id=4e3b9bc0"
import script from "./RejectionCauseList.vue?vue&type=script&lang=js"
export * from "./RejectionCauseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports